import { Box } from '@mui/material'
import { useContext } from 'react'

// others
import { useDeleteFeeTypeMutation } from '../../../../generated'
import { NOT_APPLICABLE } from '../../../constants'
import { AppContext } from '../../../context'
import { ActionType } from '../../../context/AppContextReducer'

// components
import { Alert } from '../../common/Alert'
import CustomMenu from '../../common/CustomMenu'
import { DeleteModalContent } from '../../common/DeleteModalContent'
import FeeTypeModal from './FeeTypeModal'
import { FeeTypeMenuProps } from '../../../interfaceTypes/props'

const FeeTypeMenu = ({ fee, refetch }: FeeTypeMenuProps ) => {
  const { dispatch } = useContext(AppContext)
  
  const { id: feeTypeId = '' } = fee ?? {}
  
  const [deleteFeeType, { loading: deleting }] = useDeleteFeeTypeMutation({
      onError: error => {
        Alert.error(`Fee Type couldn't be deleted due to: ${error.message}`)
      },
      onCompleted: (data) => {
        const { deleteFeeType } = data || {}
        if(deleteFeeType){
          dispatch({ type: ActionType.SET_IS_DELETE_OPEN, isDeleteOpen: false })
          Alert.success('Fee Type deleted successfully')
          refetch?.()
        }
      }
    })
  
  const onDeleteFeeType = async (feeTypeId: string) => await deleteFeeType({ variables: { deleteFeeTypeId: feeTypeId  } })
  
  return ( 
    <CustomMenu 
      id={feeTypeId} 
      menuTitle='Fee Type' 
      onDelete={onDeleteFeeType} 
      deleteContent={
        <Box mt={1}>
         <DeleteModalContent label="Fee Type" value={fee.feeType || NOT_APPLICABLE} />
        </Box>
      }
      deleting={deleting}
      modal={
        <FeeTypeModal isOpen={true} fee={fee} refetch={refetch} />
      }
    />
  )
}

export default FeeTypeMenu